{
  "level": "eb08",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:eb08",
    "objects": "AREAS.E3:eb08.e3",
    "mesh": "TREES.E3:eb08.e3"
  },
  "spawn_point": {
    "position": [
      1847.4064058344416,
      1829.735813871343,
      684.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      1847.4064058344416,
      1929.735813871343,
      684.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      1748.0,
      1714.9998779296875,
      660.0
    ],
    "bbox_max": [
      2062.739501953125,
      1986.3719482421875,
      1130.0
    ],
    "vertex_count": 47,
    "vertices": [
      [
        1806.3682861328125,
        1934.163330078125,
        1100.0
      ],
      [
        1750.0,
        1760.0,
        1100.0
      ],
      [
        1762.0576171875,
        1805.0001220703125,
        1100.0
      ],
      [
        1762.0576171875,
        1714.9998779296875,
        1100.0
      ],
      [
        1750.0,
        1760.0,
        1100.0
      ],
      [
        1762.0576171875,
        1805.0001220703125,
        1100.0
      ],
      [
        1794.9998779296875,
        1837.9422607421875,
        1100.0
      ],
      [
        1871.6220703125,
        1838.01513671875,
        1110.0
      ],
      [
        1850.1861572265625,
        1838.01513671875,
        1110.0
      ],
      [
        1750.0,
        1760.0,
        1110.0
      ],
      [
        1762.0576171875,
        1714.9998779296875,
        1110.0
      ],
      [
        1748.0,
        1760.0,
        1110.0
      ],
      [
        1750.0,
        1760.0,
        1110.0
      ],
      [
        1794.9998779296875,
        1837.9422607421875,
        1110.0
      ],
      [
        1762.0576171875,
        1805.0001220703125,
        1110.0
      ],
      [
        1785.8492431640625,
        1828.791748046875,
        1115.0
      ],
      [
        1785.8492431640625,
        1828.791748046875,
        1110.0
      ],
      [
        1871.6220703125,
        1838.01513671875,
        1115.0
      ],
      [
        1871.6220703125,
        1838.01513671875,
        1110.0
      ],
      [
        1885.000244140625,
        1837.9425048828125,
        1110.0
      ],
      [
        1885.0421142578125,
        1838.01513671875,
        1130.0
      ],
      [
        1885.042236328125,
        1838.01513671875,
        1110.0
      ],
      [
        1885.042236328125,
        1838.01513671875,
        1106.0
      ],
      [
        1884.7291259765625,
        1838.01513671875,
        1106.0
      ],
      [
        1894.8270263671875,
        1838.01513671875,
        1106.0
      ],
      [
        1885.042236328125,
        1838.01513671875,
        1106.0
      ],
      [
        1795.2718505859375,
        1838.01513671875,
        1106.0
      ],
      [
        1794.957763671875,
        1838.01513671875,
        1106.0
      ],
      [
        1899.069580078125,
        1838.01513671875,
        1103.0
      ],
      [
        1894.8270263671875,
        1838.01513671875,
        1106.0
      ],
      [
        1899.069580078125,
        1838.01513671875,
        1100.0
      ],
      [
        1899.069580078125,
        1838.01513671875,
        1103.0
      ],
      [
        1885.042236328125,
        1838.01513671875,
        1106.0
      ],
      [
        1886.000244140625,
        1839.674560546875,
        1125.0
      ],
      [
        1840.000244140625,
        1852.0001220703125,
        1125.0
      ],
      [
        1886.000244140625,
        1839.674560546875,
        1125.0
      ],
      [
        1885.0421142578125,
        1838.01513671875,
        1125.0
      ],
      [
        1886.000244140625,
        1839.674560546875,
        1111.068115234375
      ],
      [
        1840.000244140625,
        1852.0001220703125,
        1111.0682373046875
      ],
      [
        1871.9825439453125,
        1839.3602294921875,
        1115.0
      ],
      [
        1873.0001220703125,
        1843.157958984375,
        1111.0682373046875
      ],
      [
        1886.000244140625,
        1839.674560546875,
        1111.0682373046875
      ],
      [
        1886.000244140625,
        1839.674560546875,
        1110.0
      ],
      [
        1885.042236328125,
        1838.01513671875,
        1110.0
      ],
      [
        1885.042236328125,
        1838.01513671875,
        1112.919189453125
      ],
      [
        1991.810791015625,
        1986.3719482421875,
        660.0
      ],
      [
        2062.739501953125,
        1915.443359375,
        660.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        -0.0
      ],
      "plane_d": -2765.5,
      "bbox_min": [
        1658.9056396484375,
        1683.941650390625,
        630.0
      ],
      "bbox_max": [
        2096.6806640625,
        2019.60595703125,
        1150.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1658.9056396484375,
        1683.941650390625,
        1060.0
      ],
      "bbox_max": [
        2063.093017578125,
        1941.094482421875,
        1150.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.9659257531166077,
        -0.258819580078125,
        0.0
      ],
      "plane_d": -1234.84765625,
      "bbox_min": [
        1750.0,
        1715.0,
        1130.0
      ],
      "bbox_max": [
        1805.352783203125,
        1837.9422607421875,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659257531166077,
        0.258819580078125,
        -0.0
      ],
      "plane_d": -2145.892578125,
      "bbox_min": [
        1750.0,
        1715.0,
        1130.0
      ],
      "bbox_max": [
        1805.352783203125,
        1837.9422607421875,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 30.3648681640625,
      "bbox_min": [
        1750.0,
        1715.0,
        1130.0
      ],
      "bbox_max": [
        1805.352783203125,
        1837.9422607421875,
        1150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4319744408130646,
        0.11574745178222656,
        0.8944275379180908
      ],
      "plane_d": -1979.318115234375,
      "bbox_min": [
        1750.0,
        1715.0,
        1130.0
      ],
      "bbox_max": [
        1805.352783203125,
        1837.9422607421875,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4319747984409332,
        -0.11574754863977432,
        0.8944273591041565
      ],
      "plane_d": -1571.887451171875,
      "bbox_min": [
        1750.0,
        1760.0,
        1130.0
      ],
      "bbox_max": [
        1805.352783203125,
        1837.9422607421875,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3162274956703186,
        -0.3162274956703186,
        0.8944274187088013
      ],
      "plane_d": -1006.0677490234375,
      "bbox_min": [
        1762.0577392578125,
        1794.647216796875,
        1130.0
      ],
      "bbox_max": [
        1805.352783203125,
        1837.9422607421875,
        1140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659258723258972,
        -0.2588188946247101,
        0.0
      ],
      "plane_d": -1144.8489990234375,
      "bbox_min": [
        1658.9056396484375,
        1683.941650390625,
        1060.0
      ],
      "bbox_max": [
        2063.093017578125,
        1941.094482421875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659258723258972,
        0.2588188946247101,
        0.0
      ],
      "plane_d": -2085.8916015625,
      "bbox_min": [
        1658.9056396484375,
        1683.941650390625,
        1060.0
      ],
      "bbox_max": [
        2063.093017578125,
        1941.094482421875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.258817583322525,
        0.9659262895584106,
        0.0
      ],
      "plane_d": -2136.88427734375,
      "bbox_min": [
        1658.9056396484375,
        1760.0,
        1100.0
      ],
      "bbox_max": [
        1687.8834228515625,
        1767.7645263671875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071059942245483,
        -0.7071075439453125,
        0.0
      ],
      "plane_d": 90.3675537109375,
      "bbox_min": [
        1708.26318359375,
        1714.9998779296875,
        1060.0
      ],
      "bbox_max": [
        2063.093017578125,
        1941.094482421875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1756.177001953125,
        1891.7366943359375,
        1100.0
      ],
      "bbox_max": [
        1806.3682861328125,
        1934.163330078125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659252762794495,
        0.25882139801979065,
        0.0
      ],
      "plane_d": -2193.457763671875,
      "bbox_min": [
        1756.177001953125,
        1891.7366943359375,
        1100.0
      ],
      "bbox_max": [
        1763.941650390625,
        1920.7144775390625,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1100.0,
      "bbox_min": [
        1708.26318359375,
        1714.9998779296875,
        1060.0
      ],
      "bbox_max": [
        2063.093017578125,
        1941.094482421875,
        1130.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.9659257531166077,
        0.258819580078125,
        3.2501097848580685e-06
      ],
      "plane_d": -2145.89599609375,
      "bbox_min": [
        1750.0,
        1714.9998779296875,
        1060.0
      ],
      "bbox_max": [
        1795.0,
        1837.9422607421875,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 30.360889434814453,
      "bbox_min": [
        1762.0576171875,
        1805.0,
        1060.0
      ],
      "bbox_max": [
        1795.0,
        1837.9422607421875,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1838.01513671875,
      "bbox_min": [
        1742.7530517578125,
        1714.9998779296875,
        1100.0
      ],
      "bbox_max": [
        2063.093017578125,
        1873.4793701171875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1742.7530517578125,
        1714.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1926.908203125,
        1838.01513671875,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9659265279769897,
        0.2588164508342743,
        -0.0
      ],
      "plane_d": -2145.888427734375,
      "bbox_min": [
        1748.0,
        1714.9998779296875,
        1110.0
      ],
      "bbox_max": [
        1885.042236328125,
        1838.01513671875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1748.0,
        1760.0,
        1110.0
      ],
      "bbox_max": [
        1750.0,
        1760.0,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071055173873901,
        -0.7071081399917603,
        -3.5965247207059292e-06
      ],
      "plane_d": 30.373571395874023,
      "bbox_min": [
        1762.0576171875,
        1780.0,
        1110.0
      ],
      "bbox_max": [
        1885.042236328125,
        1838.01513671875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2555.9375,
      "bbox_min": [
        1784.4832763671875,
        1828.791748046875,
        1110.0
      ],
      "bbox_max": [
        1785.8492431640625,
        1830.15771484375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2555.9375,
      "bbox_min": [
        1785.8492431640625,
        1780.0,
        1110.0
      ],
      "bbox_max": [
        1885.042236328125,
        1838.01513671875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659256935119629,
        -0.2588197886943817,
        0.0
      ],
      "plane_d": -1332.1331787109375,
      "bbox_min": [
        1820.0,
        1780.0,
        1110.0
      ],
      "bbox_max": [
        1885.042236328125,
        1838.01513671875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25882017612457275,
        0.9659255146980286,
        0.0
      ],
      "plane_d": -1262.436767578125,
      "bbox_min": [
        1820.0,
        1794.6409912109375,
        1115.0
      ],
      "bbox_max": [
        1860.0,
        1800.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25882017612457275,
        0.9659255146980286,
        -0.0
      ],
      "plane_d": -2214.89501953125,
      "bbox_min": [
        1840.0,
        1794.6409912109375,
        1115.0
      ],
      "bbox_max": [
        1860.0,
        1800.0,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2584.2216796875,
      "bbox_min": [
        1860.0,
        1780.0,
        1110.0
      ],
      "bbox_max": [
        1885.042236328125,
        1838.01513671875,
        1130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8660261034965515,
        -0.4999989867210388,
        0.0
      ],
      "plane_d": -713.4900512695312,
      "bbox_min": [
        1885.0001220703125,
        1837.9423828125,
        1110.0
      ],
      "bbox_max": [
        1885.042236328125,
        1838.01513671875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1106.0,
      "bbox_min": [
        1742.7530517578125,
        1714.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1926.908203125,
        1838.01513671875,
        1110.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9659265279769897,
        -0.2588164508342743,
        0.0
      ],
      "plane_d": -1234.8544921875,
      "bbox_min": [
        1750.0,
        1714.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1926.908203125,
        1838.01513671875,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659257531166077,
        0.258819580078125,
        3.2501097848580685e-06
      ],
      "plane_d": -2145.89599609375,
      "bbox_min": [
        1750.0,
        1714.9998779296875,
        1100.0
      ],
      "bbox_max": [
        1926.908203125,
        1838.01513671875,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        3.75290255760774e-06
      ],
      "plane_d": 30.360889434814453,
      "bbox_min": [
        1762.0576171875,
        1805.0001220703125,
        1100.0
      ],
      "bbox_max": [
        1926.908203125,
        1838.01513671875,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000050663948059,
        0.5000050663948059,
        0.7070995569229126
      ],
      "plane_d": -2648.4921875,
      "bbox_min": [
        1894.8270263671875,
        1808.6236572265625,
        1100.0
      ],
      "bbox_max": [
        1926.908203125,
        1838.01513671875,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2642.51806640625,
      "bbox_min": [
        1899.069580078125,
        1810.176513671875,
        1100.0
      ],
      "bbox_max": [
        1926.908203125,
        1838.01513671875,
        1103.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659265279769897,
        0.2588164508342743,
        -0.0
      ],
      "plane_d": -2145.888427734375,
      "bbox_min": [
        1748.0,
        1714.9998779296875,
        1106.0
      ],
      "bbox_max": [
        1885.042236328125,
        1838.01513671875,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -1760.0,
      "bbox_min": [
        1748.0,
        1760.0,
        1106.0
      ],
      "bbox_max": [
        1750.0,
        1760.0,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071055173873901,
        -0.7071081399917603,
        -3.5965247207059292e-06
      ],
      "plane_d": 30.373571395874023,
      "bbox_min": [
        1762.0576171875,
        1805.0001220703125,
        1106.0
      ],
      "bbox_max": [
        1885.042236328125,
        1838.01513671875,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660261034965515,
        -0.4999989867210388,
        0.0
      ],
      "plane_d": -713.4900512695312,
      "bbox_min": [
        1885.000244140625,
        1837.9425048828125,
        1106.0
      ],
      "bbox_max": [
        1885.042236328125,
        1838.01513671875,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1125.0,
      "bbox_min": [
        1791.37646484375,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        2063.093017578125,
        1873.4793701171875,
        1130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.25881707668304443,
        0.9659264087677002,
        -0.0
      ],
      "plane_d": -2265.119384765625,
      "bbox_min": [
        1840.000244140625,
        1838.01513671875,
        1125.0
      ],
      "bbox_max": [
        1886.000244140625,
        1852.0001220703125,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660261034965515,
        -0.4999989867210388,
        0.0
      ],
      "plane_d": -713.4900512695312,
      "bbox_min": [
        1885.0421142578125,
        1838.01513671875,
        1125.0
      ],
      "bbox_max": [
        1886.000244140625,
        1839.674560546875,
        1130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881925225257874,
        0.9659258127212524,
        -0.0
      ],
      "plane_d": -2273.1904296875,
      "bbox_min": [
        1791.37646484375,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        2063.093017578125,
        1873.4793701171875,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1830141395330429,
        0.6830175518989563,
        0.7071017026901245
      ],
      "plane_d": -2387.3330078125,
      "bbox_min": [
        1791.37646484375,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        1899.069580078125,
        1860.3529052734375,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -1106.0,
      "bbox_min": [
        1791.37646484375,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        1899.069580078125,
        1857.2470703125,
        1115.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -2642.51806640625,
      "bbox_min": [
        1888.6236572265625,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        1899.069580078125,
        1846.908203125,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000050663948059,
        0.5000050663948059,
        0.7070995569229126
      ],
      "plane_d": -2648.4921875,
      "bbox_min": [
        1888.6236572265625,
        1838.01513671875,
        1103.0
      ],
      "bbox_max": [
        1899.069580078125,
        1846.908203125,
        1106.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881707668304443,
        0.9659264087677002,
        -0.0
      ],
      "plane_d": -2265.119384765625,
      "bbox_min": [
        1840.000244140625,
        1838.01513671875,
        1106.0
      ],
      "bbox_max": [
        1886.000244140625,
        1852.0001220703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1110.0,
      "bbox_min": [
        1850.1861572265625,
        1838.01513671875,
        1106.0
      ],
      "bbox_max": [
        1886.000244140625,
        1848.516845703125,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659256935119629,
        -0.2588197886943817,
        0.0
      ],
      "plane_d": -1332.1331787109375,
      "bbox_min": [
        1871.6220703125,
        1838.01513671875,
        1110.0
      ],
      "bbox_max": [
        1886.000244140625,
        1843.157958984375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660261034965515,
        -0.4999989867210388,
        0.0
      ],
      "plane_d": -713.4900512695312,
      "bbox_min": [
        1885.042236328125,
        1838.01513671875,
        1110.0
      ],
      "bbox_max": [
        1886.000244140625,
        1839.674560546875,
        1112.919189453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660261034965515,
        -0.4999989867210388,
        0.0
      ],
      "plane_d": -713.4900512695312,
      "bbox_min": [
        1885.042236328125,
        1838.01513671875,
        1106.0
      ],
      "bbox_max": [
        1886.000244140625,
        1839.674560546875,
        1110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.25881707668304443,
        0.9659264087677002,
        -0.0
      ],
      "plane_d": -2265.119384765625,
      "bbox_min": [
        1840.000244140625,
        1838.01513671875,
        1111.068115234375
      ],
      "bbox_max": [
        1886.000244140625,
        1852.0001220703125,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8660261034965515,
        -0.4999989867210388,
        0.0
      ],
      "plane_d": -713.4900512695312,
      "bbox_min": [
        1871.9825439453125,
        1838.01513671875,
        1111.0682373046875
      ],
      "bbox_max": [
        1886.000244140625,
        1843.157958984375,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9659256935119629,
        -0.2588197886943817,
        0.0
      ],
      "plane_d": -1332.1331787109375,
      "bbox_min": [
        1871.9825439453125,
        1839.3602294921875,
        1111.0682373046875
      ],
      "bbox_max": [
        1873.0001220703125,
        1843.157958984375,
        1115.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1866.4083251953125,
      "bbox_min": [
        1983.800048828125,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        2063.093017578125,
        1873.4793701171875,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071006894111633,
        -0.7071129083633423,
        0.0
      ],
      "plane_d": 2763.4990234375,
      "bbox_min": [
        2027.628662109375,
        1866.4083251953125,
        1100.0
      ],
      "bbox_max": [
        2043.18505859375,
        1873.4793701171875,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -124.0001220703125,
      "bbox_min": [
        2041.7708740234375,
        1866.4083251953125,
        1100.0
      ],
      "bbox_max": [
        2043.18505859375,
        1867.822509765625,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -114.0,
      "bbox_min": [
        2027.628662109375,
        1866.4083251953125,
        1100.0
      ],
      "bbox_max": [
        2034.69970703125,
        1873.4793701171875,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2763.5,
      "bbox_min": [
        2056.02197265625,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        2063.093017578125,
        1853.571533203125,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071678042411804,
        0.7070457339286804,
        0.0
      ],
      "plane_d": 144.3927001953125,
      "bbox_min": [
        2056.02197265625,
        1852.1572265625,
        1100.0
      ],
      "bbox_max": [
        2057.43603515625,
        1853.571533203125,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 154.154052734375,
      "bbox_min": [
        2056.02197265625,
        1838.01513671875,
        1100.0
      ],
      "bbox_max": [
        2063.093017578125,
        1845.086181640625,
        1125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7070997953414917,
        0.7071138024330139,
        0.0
      ],
      "plane_d": 144.1265869140625,
      "bbox_min": [
        1975.54736328125,
        1853.571533203125,
        630.0
      ],
      "bbox_max": [
        2096.6806640625,
        2019.60595703125,
        1135.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.7071037888526917,
        -0.707109808921814,
        -0.0
      ],
      "plane_d": 2782.99951171875,
      "bbox_min": [
        1975.54736328125,
        1853.571533203125,
        630.0
      ],
      "bbox_max": [
        2096.6806640625,
        2019.60595703125,
        1135.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        1975.54736328125,
        1869.4814453125,
        630.0
      ],
      "bbox_max": [
        2096.6806640625,
        2019.60595703125,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071061730384827,
        -0.7071073651313782,
        -0.0
      ],
      "plane_d": 2813.0,
      "bbox_min": [
        1991.810791015625,
        1915.443359375,
        660.0
      ],
      "bbox_max": [
        2062.739501953125,
        1986.3719482421875,
        665.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071062922477722,
        -0.7071073651313782,
        0.0
      ],
      "plane_d": 2855.0,
      "bbox_min": [
        1975.54736328125,
        1869.4814453125,
        630.0
      ],
      "bbox_max": [
        2096.6806640625,
        2019.60595703125,
        660.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071061730384827,
        -0.7071073651313782,
        -0.0
      ],
      "plane_d": 2813.0,
      "bbox_min": [
        1975.54736328125,
        1869.4814453125,
        630.0
      ],
      "bbox_max": [
        2085.366943359375,
        1986.3719482421875,
        660.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -79.0,
      "bbox_min": [
        2046.3670654296875,
        1920.8555908203125,
        630.0
      ],
      "bbox_max": [
        2074.6513671875,
        1962.928466796875,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070762515068054,
        -0.7071372866630554,
        0.0
      ],
      "plane_d": -86.3785400390625,
      "bbox_min": [
        2050.256103515625,
        1920.8555908203125,
        635.0
      ],
      "bbox_max": [
        2058.741455078125,
        1929.3408203125,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        2050.256103515625,
        1920.8555908203125,
        635.0
      ],
      "bbox_max": [
        2058.741455078125,
        1929.3408203125,
        650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -635.0,
      "bbox_min": [
        2050.256103515625,
        1920.8555908203125,
        635.0
      ],
      "bbox_max": [
        2058.741455078125,
        1929.3408203125,
        635.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -635.0,
      "bbox_min": [
        1975.54736328125,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2085.366943359375,
        1986.3719482421875,
        653.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071037292480469,
        -0.707109808921814,
        -0.0
      ],
      "plane_d": 2809.99951171875,
      "bbox_min": [
        2050.011474609375,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2085.366943359375,
        1909.7864990234375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 653.0,
      "bbox_min": [
        2050.011474609375,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2085.366943359375,
        1909.7864990234375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.980579674243927,
        0.19612134993076324,
        0.0
      ],
      "plane_d": 1674.4788818359375,
      "bbox_min": [
        2050.011474609375,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2085.366943359375,
        1909.7864990234375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 2805.000244140625,
      "bbox_min": [
        2050.011474609375,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2076.528076171875,
        1909.7864990234375,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071312069892883,
        -0.7070823311805725,
        0.0
      ],
      "plane_d": -119.2510986328125,
      "bbox_min": [
        2067.689208984375,
        1899.1798095703125,
        635.0
      ],
      "bbox_max": [
        2071.224609375,
        1902.7154541015625,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -119.1541748046875,
      "bbox_min": [
        2050.011474609375,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2076.528076171875,
        1909.7864990234375,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        2050.011474609375,
        1892.1087646484375,
        648.0
      ],
      "bbox_max": [
        2067.689208984375,
        1909.7864990234375,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -2785.000244140625,
      "bbox_min": [
        2053.547119140625,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2076.528076171875,
        1885.0377197265625,
        653.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7070762515068054,
        0.7071372866630554,
        0.0
      ],
      "plane_d": 139.0338134765625,
      "bbox_min": [
        2059.094970703125,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2067.689208984375,
        1878.0755615234375,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7070762515068054,
        -0.7071372866630554,
        0.0
      ],
      "plane_d": -128.8798828125,
      "bbox_min": [
        2059.094970703125,
        1869.4814453125,
        635.0
      ],
      "bbox_max": [
        2067.689208984375,
        1878.0755615234375,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 648.0,
      "bbox_min": [
        2059.094970703125,
        1869.4814453125,
        648.0
      ],
      "bbox_max": [
        2067.689208984375,
        1878.0755615234375,
        648.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19610832631587982,
        0.9805822372436523,
        0.0
      ],
      "plane_d": -1429.075927734375,
      "bbox_min": [
        2067.689208984375,
        1870.8956298828125,
        635.0
      ],
      "bbox_max": [
        2076.528076171875,
        1872.663330078125,
        653.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071102857589722,
        -0.7071033120155334,
        0.0
      ],
      "plane_d": -124.0137939453125,
      "bbox_min": [
        2043.18505859375,
        1853.571533203125,
        635.0
      ],
      "bbox_max": [
        2069.810546875,
        1880.1968994140625,
        1135.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1135.0,
      "bbox_min": [
        2043.18505859375,
        1853.571533203125,
        635.0
      ],
      "bbox_max": [
        2069.810546875,
        1880.1968994140625,
        1135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -635.0,
      "bbox_min": [
        2043.18505859375,
        1853.571533203125,
        635.0
      ],
      "bbox_max": [
        2069.810546875,
        1880.1968994140625,
        635.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}